import { isNull } from '../../../../ui/utils';

function getAdjustmentPayload({ quote, requestId, notes = '' }) {
  const { adjustmentFactor, locations: adjustedLocations, fees: adjustedFees, targetPremium, lossPick, arrayOfPerOccDedOptions } = quote;
  console.log('getAdjustmentPayload - quote', {
    adjustmentFactor,
    locations: [...adjustedLocations],
    fees: [...adjustedFees],
    targetPremium,
    arrayOfPerOccDedOptions,
  });
  // check
  for (const loc of adjustedLocations) {
    const { coveredValue, coverages = [] } = loc;
    const validCoveredValue = coveredValue && typeof coveredValue === 'number' && coveredValue > 0;
    for (const cov of coverages) {
      const { payoutLimit } = cov;
      if (validCoveredValue && payoutLimit > coveredValue) {
        throw 'Invalid payoutlimit';
      }
    }
  }
  delete quote.application;
  delete quote.limits;
  // Presence, not truthiness, for both operands: 0 is a statable (if invalid) target premium or
  // loss pick, and must still declare its mode and carry its value so the server — not the
  // client — rejects it, rather than the client silently falling back to legacy pricing or
  // declaring a mode with no value behind it.
  const isStated = (value) => value !== undefined && value !== null && value !== '';
  const hasLossPick = isStated(lossPick);
  const hasTargetPremium = isStated(targetPremium);
  // The two are mutually exclusive on the server (insurance.quotes allows one of the pair), so with
  // both populated there is no defensible way to pick a basis — silently preferring either one
  // reprices the quote off an input the underwriter did not mean to state. Refuse instead: the
  // confirm handlers clear whichever field is being replaced, so this is a bug in the caller.
  if (hasLossPick && hasTargetPremium) {
    throw 'Ambiguous pricing basis: a quote may state a target premium or a loss pick, not both';
  }
  if (!hasTargetPremium) delete quote.targetPremium;
  // Omitted when neither is set so a TIV/deductible-only adjustment keeps today's
  // adjustment-factor path instead of declaring a mode with nothing to price from.
  if (hasLossPick || hasTargetPremium) {
    quote.pricingMode = hasLossPick ? 'TARGET_LOSS_PICK' : 'TARGET_PREMIUM';
  }
  // Always sent, including as null, so a declared TARGET_LOSS_PICK never arrives with nothing
  // behind it. The server reads pricingMode, not this key's presence, to decide the basis — an
  // absent key and an explicit null are indistinguishable to it, and a request that declares no
  // mode clears the stored pick either way.
  quote.lossPick = hasLossPick ? lossPick : null;
  if (!arrayOfPerOccDedOptions || arrayOfPerOccDedOptions.length === 0) delete quote.arrayOfPerOccDedOptions;

  const payload = {
    ...(!isNull(requestId) ? { requestId } : null),
    notes: notes || '',
    quote,
  };
  return payload;
}

export default getAdjustmentPayload;
